import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { IconWrapper } from "../IconWrapper/index.js";
import { Tooltip } from "../Tooltip/index.js";
import { cn as clsx } from "../../helpers/react.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index38.css';const timeCell = "_timeCell_1qv0h_1";
const interactable = "_interactable_1qv0h_12";
const label = "_label_1qv0h_18";
const time = "_time_1qv0h_1";
const dateTime = "_dateTime_1qv0h_20";
const bigValue = "_bigValue_1qv0h_43";
const date = "_date_1qv0h_20";
const spinner = "_spinner_1qv0h_89";
const spinnerAnimation = "_spinnerAnimation_1qv0h_1";
const s = {
  timeCell,
  interactable,
  label,
  time,
  dateTime,
  bigValue,
  date,
  spinner,
  spinnerAnimation
};
const AnimationSpinner = /* @__PURE__ */ jsx(IconWrapper, { size: "sm", children: /* @__PURE__ */ jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx("path", { d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z", opacity: ".25" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z",
      className: s.spinner,
      fill: "currentColor"
    }
  )
] }) });
const TimeCell = withThemeAndSize(
  forwardRef(
    ({ className, label: label2, primaryDateValue, secondaryDateValue, isBigValue, isSpinnerEnabled, interactable: interactable2, ...rest }, ref) => {
      let timeToShow = primaryDateValue == null ? void 0 : primaryDateValue.value;
      return /* @__PURE__ */ jsxs("div", { ...rest, className: clsx(s.timeCell, className, { [s.interactable]: interactable2 }), ref, children: [
        /* @__PURE__ */ jsx(Tooltip, { content: label2 == null ? void 0 : label2.tooltip, side: "top", children: /* @__PURE__ */ jsx("span", { "data-testid": label2 == null ? void 0 : label2.testId, className: clsx(s.label, { [s.bigValue]: isBigValue }), children: label2 == null ? void 0 : label2.value }) }),
        isSpinnerEnabled && AnimationSpinner,
        /* @__PURE__ */ jsx(Tooltip, { content: primaryDateValue == null ? void 0 : primaryDateValue.tooltip, side: "top", children: /* @__PURE__ */ jsxs("div", { className: s.dateTime, children: [
          /* @__PURE__ */ jsx("span", { "data-testid": primaryDateValue == null ? void 0 : primaryDateValue.testId, className: clsx(s.time, { [s.bigValue]: isBigValue }), children: timeToShow }),
          Boolean(secondaryDateValue && secondaryDateValue.value) && /* @__PURE__ */ jsx("span", { "data-testid": secondaryDateValue == null ? void 0 : secondaryDateValue.testId, className: s.date, children: secondaryDateValue == null ? void 0 : secondaryDateValue.value })
        ] }) })
      ] });
    }
  )
);
export {
  TimeCell
};
